export function calculateEffectiveCcDuration(baseDuration, tenacityPercent, ccType) {
  // Displacements (Knockups, Knockbacks) & Suppression are NOT affected by Tenacity
  if (ccType === 'knockup' || ccType === 'knockback' || ccType === 'suppression') {
    return baseDuration;
  }

  const reduction = Math.min(1.0, Math.max(0, tenacityPercent / 100));
  const effective = baseDuration * (1 - reduction);
  return Math.round(effective * 100) / 100;
}
